<template lang="html">
  <div data-tap-disabled="true">
    <mapbox
      :map-options="mapOptions"
      @map-init="onMapInitialized"
      @map-load="onMapLoaded"
      @map-click="onMapClicked"
      :access-token="mapAccessToken"
      :class="{ minimized: mapMinimized }"
      :scale-control="{
        show: true,
        position: 'bottom-left'
      }"
      :nav-control="{
        show: true
      }"
    >
    </mapbox>
  </div>
</template>

<script>
import mapboxgl from "mapbox-gl";
import Mapbox from "mapbox-gl-vue";
import MapService from "../../services/map-service";
import PacketService from "../../services/packet-service";
import ApiService from "../../services/api-service";
import PopupContent from "./PopupContent";

export default {
  name: "indoorNavigation",

  props: {
    markers: Array,
    application: Object,
    mapStyle: String
  },

  data() {
    return {
      mapMinimized: false,
      map: null,
      mapAccessToken: MapService.getAccessToken("default"),
      mapOptions: MapService.getOptions("default"),
      mapDevices: this.markers,
      mapPopup: null,
      popupHeader: "",
      map_style: "width: 100%;"
    };
  },

  watch: {
    markers: function(data) {
      this.setDevices(data);
      if (data.length === 1) {
        this.focusDevice(data[0]);
        //this.addPopUp(this.map, data[0]);
        //temporary use
        this.getDeviceByDeviceId(data[0], data[0].id);
      } else {
        if (this.mapPopup) {
          this.mapPopup.remove();
        }
        this.focusApplication(this.application);
      }
    },
    mapStyle: function(data) {
      this.mapOptions.style = data;
      this.map.setStyle(this.mapOptions.style);
      let mappp = this.map;
      this.map.once("style.load", function() {
        MapService.addDefaultLayers(mappp);
      });
    }
  },

  beforeCreate() {
    this.$loader.startLoading("Map");
  },

  methods: {
    setDevices(devices) {
      this.removeDeviceMarker();
      this.mapDevices = devices.map(device => {
        device.icon = "far fa-cloud";
        return device;
      });

      this.mapDevices.forEach(device => {
        this.normalizeDevicePosition(device);
        MapService.createMarker(this.map, device);
        if (this.autoSelectDevice === device.id) {
          this.selectDevice(device.id);
          this.autoSelectDevice = null;
        }
      });
    },

    focusApplication(application) {
      this.map.easeTo({
        center: [application.lon, application.lat],
        zoom: MapService.getOptions("detail").zoom - 2,
        pitch: 60
      });
    },

    focusDevice(device) {
      let defaultZoom = MapService.getOptions("default").zoomNear;
      let zoomTo = this.map.getZoom();

      if (zoomTo < defaultZoom) {
        zoomTo = defaultZoom;
      }
      this.map.easeTo({
        center: [device.lon, device.lat],
        zoom: zoomTo,
        pitch: 60,
        bearing: 0
      });
    },

    removeDeviceMarker() {
      this.mapDevices.forEach(device => {
        if (device.marker && typeof device.marker.remove === "function") {
          device.marker.remove();
        }
      });
    },

    normalizeDevicePosition(device) {
      let gps = PacketService.getGPS(device.packets);

      if (gps && gps.latitude !== 0 && gps.longitude !== 0) {
        device.lat = gps.latitude;
        device.lon = gps.longitude;
      }
    },

    onMapInitialized(map) {
      this.map = map;
    },

    addMapLayers() {
      MapService.addDefaultLayers(this.map);
    },

    onMapLoaded(map) {
      this.map = map;
      this.$loader.endLoading("Map");
      this.$Progress.finish();
      this.addMapLayers();
      if (this.mapDevices.length) {
        this.setDevices(this.mapDevices);
        setTimeout(
          function() {
            this.focusApplication(this.application);
          }.bind(this),
          700
        );
      }
    },

    onMapClicked(map, evt) {
      let deviceId = this.getClickedMarkerDeviceId(evt.originalEvent);
      if (deviceId) {
        /**
         * temporary use
         */
        let device = this.markers.find(a => a.id === deviceId);
        this.getDeviceByDeviceId(device, deviceId);
        //this.addPopUp(map, this.findDeviceById(deviceId));
      }
    },

    addPopUp(map, device) {
      let devicePosition = { lng: device.lon, lat: device.lat };

      if (this.mapPopup) {
        this.mapPopup.remove();
      }

      this.mapPopup = new mapboxgl.Popup()
        .setLngLat(devicePosition)
        .setHTML('<div id="vue-popup-content"></div>')
        .addTo(map);

      new PopupContent({
        propsData: { device: device }
      }).$mount("#vue-popup-content");
    },

    getClickedMarkerDeviceId(event) {
      let deviceId = null;
      let did = null;
      if (typeof event.path === "object") {
        event.path.forEach(el => {
          did = el.getAttribute ? el.getAttribute("did") : null;
          if (did) {
            deviceId = Number(did);
          }
        });
      } else if (event.toElement || event.srcElement) {
        if (event.toElement && event.toElement.parentElement) {
          if (event.toElement.parentElement.nodeName === "DIV") {
            did = event.toElement.parentElement.getAttribute
              ? event.toElement.parentElement.getAttribute("did")
              : null;
          } else if (
            event.toElement.parentElement.parentElement.nodeName === "DIV"
          ) {
            did = event.toElement.parentElement.parentElement.getAttribute
              ? event.toElement.parentElement.parentElement.getAttribute("did")
              : null;
          }
        } else if (event.srcElement && event.srcElement.parentElement) {
          if (event.srcElement.parentElement.nodeName === "DIV") {
            did = event.srcElement.parentElement.getAttribute
              ? event.srcElement.parentElement.getAttribute("did")
              : null;
          } else if (
            event.srcElement.parentElement.parentElement.nodeName === "DIV"
          ) {
            did = event.srcElement.parentElement.parentElement.getAttribute
              ? event.srcElement.parentElement.parentElement.getAttribute("did")
              : null;
          }
        }
      }
      if (did) {
        deviceId = Number(did);
      }
      return deviceId;
    },

    findDeviceById(deviceId) {
      return this.markers.find(a => a.id === deviceId);
    },

    getDeviceByDeviceId(device, deviceId) {
      ApiService.getDevice(this, deviceId)
        .then(result => {
          device.tags = result.tags;
          this.addPopUp(this.map, device);
        })
        .catch(response => {
          this.loading = false;
          this.$notify({
            type: "error",
            message: `Ein Fehler ist aufgetreten: ${response}`,
            position: "bottom-left"
          });
        });
    }
  },

  components: {
    Mapbox
  }
};
</script>
